export var ExprEnv;
(function (ExprEnv) {
    const { freeze } = Object;
    function make(partial = {}) {
        const now = partial.now || Date.now();
        return {
            now: freeze(new Date(now)),
        };
    }
    ExprEnv.make = make;
})(ExprEnv || (ExprEnv = {}));
